module.exports = __webpack_public_path__ + "static/media/send-message.48164c80.svg";